export default __webpack_public_path__ + "static/media/burger-icon.d0169e92.svg";